module.exports = __webpack_public_path__ + "img/manage2.1e2b603f.png";